import { render, staticRenderFns } from "./Coversheet.vue?vue&type=template&id=669b83c2"
import script from "./Coversheet.vue?vue&type=script&lang=js"
export * from "./Coversheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports